import { useContext } from "react";
import { IInstantNotifier } from "./types";
import { InstantNotifierContext } from "./instantNotifierContext";


export const useInstantNotifier = (): IInstantNotifier => {

    const notifier = useContext(InstantNotifierContext);
    if (!notifier)
        throw new Error("InstantNotifierContext not found");

    return notifier;
};  